import script from "./AsideComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AsideComponent.vue?vue&type=script&lang=ts&setup=true"

import "./AsideComponent.vue?vue&type=style&index=0&id=1e44356a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e44356a"]])

export default __exports__